import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../../../core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { Constants } from '../../../../core/services/constants.service';
import { MatRangeSliderComponent } from '../../../../shared/components/range-slider/range-slider.component';
import { AddLotDialogComponent } from './add-lot-dialog/add-lot-dialog.component';
import { LotDetailDialogComponent } from './lot-detail-dialog/lot-detail-dialog.component';
import { UpdateLotStatusDialogComponent } from './update-lot-status-dialog/update-lot-status-dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import {
    EditPackagePropertyDialogComponent
} from '../../edit/packages/property-package/edit-package-property-dialog/edit-package-property-dialog.component';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-project-detail-lots',
    templateUrl: './lots.component.html',
    styleUrls: ['./lots.component.scss']
})

export class LotsComponent implements OnInit {
    @Input() project: any;
    @ViewChild('childTabs') childTabs: MatTabGroup;
    mode = 'grid';
    lots = [];
    dataSource = new Map();
    displayedColumns = ['select', 'number', 'width', 'length', 'size', 'price', 'status', 'package'];
    constants = Constants;
    filterParams: any;
   
    // 默认搜索参数
    defaultFilterParams = {
        priceRange: {
            min: 0,
            max: 0,
            defaultMin: 0,
            defaultMax: 0
        },
        widthRange: {
            min: 0,
            max: 0,
            defaultMin: 0,
            defaultMax: 0
        },
        lengthRange: {
            min: 0,
            max: 0,
            defaultMin: 0,
            defaultMax: 0
        },
        status: [
            { value: [0], label: 'Unavailable', isChecked: false },
            { value: [1], label: 'Available', isChecked: false },
            { value: [2, 3], label: 'Reserved', isChecked: false },
            { value: [4, 5], label: 'Processing', isChecked: false },
            { value: [6], label: 'Sold', isChecked: false },
        ],
        parkFront: [
            { value: 1, label: 'Yes', isChecked: false },
            { value: 0, label: 'No', isChecked: false },
        ],
        lakeFront: [
            { value: 1, label: 'Yes', isChecked: false },
            { value: 0, label: 'No', isChecked: false },
        ],
        cornerBlock: [
            { value: 1, label: 'Yes', isChecked: false },
            { value: 0, label: 'No', isChecked: false },
        ]
    };
    // 搜索 slider 最大最小值
    minWidth = 0;
    maxWidth = 0;
    minLength = 0;
    maxLength = 0;
    minPrice = 0;
    maxPrice = 0;
    keywords = '';
    isFiltered = false;
    dataSourceCount = 0;
    selectedLots = [];
    buildings = [];
    showDetailDialog = false;
    showStatusBar = false;
    currentBuildingId: any;
    windowHeight: number;
    priceArray = [
            { value: 50000, label: '$50,000', isChecked: false },
            { value: 75000, label: '$75,000', isChecked: false },
            { value: 100000, label: '$100,000', isChecked: false },
            { value: 125000, label: '$125,000', isChecked: false },
            { value: 150000, label: '$150,000', isChecked: false },
            { value: 175000, label: '$175,000', isChecked: false },
            { value: 200000, label: '$200,000', isChecked: false },
            { value: 225000, label: '$225,000', isChecked: false },
            { value: 250000, label: '$250,000', isChecked: false },
            { value: 275000, label: '$275,000', isChecked: false },
            { value: 300000, label: '$300,000', isChecked: false },
            { value: 350000, label: '$350,000', isChecked: false },
            { value: 375000, label: '$375,000', isChecked: false },
            { value: 400000, label: '$400,000', isChecked: false },
            { value: 425000, label: '$425,000', isChecked: false },
            { value: 450000, label: '$450,000', isChecked: false },

            { value: 475000, label: '$475,000', isChecked: false },
            { value: 500000, label: '$500,000', isChecked: false },
            { value: 550000, label: '$550,000', isChecked: false },
            { value: 600000, label: '$600,000', isChecked: false },
            { value: 650000, label: '$650,000', isChecked: false },

            { value: 700000, label: '$700,000', isChecked: false },
            { value: 750000, label: '$750,000', isChecked: false },
            { value: 800000, label: '$800,000', isChecked: false },
            { value: 850000, label: '$850,000', isChecked: false },
            { value: 900000, label: '$900,000', isChecked: false },

            { value: 950000, label: '$950,000', isChecked: false },
            { value: 1000000, label: '$1,000,000', isChecked: false },
            { value: 1100000, label: '$1,100,000', isChecked: false },
            { value: 1200000, label: '$1,200,000', isChecked: false },
            { value: 1300000, label: '$1,300,000', isChecked: false },
            { value: 1400000, label: '$1,400,000', isChecked: false },
            { value: 1500000, label: '$1,500,000', isChecked: false },
    ];
    widthArray = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
    lengthArray = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
    @ViewChild('priceRangeSlider') private priceRangeSlider: MatRangeSliderComponent<any>;
    @ViewChild('widthRangeSlider') private widthRangeSlider: MatRangeSliderComponent<any>;
    @ViewChild('lengthRangeSlider') private lengthRangeSlider: MatRangeSliderComponent<any>;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private httpService: HttpService,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit(): void {

        console.log(this.project);
        // compatible old lots
        // const oldData = this.project.lots && this.project.lots.length > 0 ? [JSON.parse(JSON.stringify(this.project))] : [];
        this.buildings = this.project.buildings ? JSON.parse(JSON.stringify(this.project.buildings)) : [];
        // this.buildings = oldData.concat(this.buildings);
        console.log(this.buildings);

        this.updateSourceData(this.buildings);

        this.initFilterParams();
    }

    initFilterParams() {
        if (this.buildings.length) {
            this.lots = this.buildings.map((building) => {
                return building.lots ? building.lots : [];
            }).reduce((a, b) => a.concat(b));

            const priceArray = [];
            const widthArray = [];
            const lengthArray = [];
            this.lots.map(lot => {
                priceArray.push(lot.price);
                widthArray.push(lot.width);
                lengthArray.push(lot.length);
            });
          
            // this.widthArray = widthArray.reverse()
            // this.lengthArray = lengthArray.reverse()

            this.minPrice = Math.min(...priceArray);
            this.maxPrice = Math.max(...priceArray);

            
            this.defaultFilterParams.priceRange.min = this.minPrice;
            this.defaultFilterParams.priceRange.max = this.maxPrice;

            this.minWidth = Math.min(...widthArray);
            this.maxWidth = Math.max(...widthArray);
            this.defaultFilterParams.widthRange.min = this.minWidth;
            this.defaultFilterParams.widthRange.max = this.maxWidth;

            this.minLength = Math.min(...lengthArray);
            this.maxLength = Math.max(...lengthArray);
            this.defaultFilterParams.lengthRange.min = this.minLength;
            this.defaultFilterParams.lengthRange.max = this.maxLength;
        }

        this.filterParams = JSON.parse(JSON.stringify(this.defaultFilterParams));
    }


    ngAfterViewChecked(): void {
        if (this.childTabs) {
            this.childTabs.realignInkBar();
        }
    }

    // 页面高度撑满屏幕
    ngAfterViewInit(): void {
        this.windowHeight = window.innerHeight;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.windowHeight = window.innerHeight;
    }

    filterData() {
        if(this.filterParams.widthRange.min>this.filterParams.widthRange.max) {
            this.toastrService.error('Max Width must be greater than Min Width');
            return
        }
        if(this.filterParams.lengthRange.min>this.filterParams.lengthRange.max) {
            this.toastrService.error('Max Length must be greater than Min Length');
            return
        }
        if(this.filterParams.priceRange.min>this.filterParams.priceRange.max) {
            this.toastrService.error('Max Price must be greater than Min Price');
            return
        }
        const statusParams = [].concat(...this.filterParams.status.filter((status) => status.isChecked).map((status) => status.value));

        const parkFrontParams = this.filterParams.parkFront.filter((item) => item.isChecked).map((item) => item.value);
        const lakeFrontParams = this.filterParams.lakeFront.filter((item) => item.isChecked).map((item) => item.value);
        const cornerBlockParams = this.filterParams.cornerBlock.filter((item) => item.isChecked).map((item) => item.value);
        const priceRangeParams = this.filterParams.priceRange;
        const widthRangeParams = this.filterParams.widthRange;
        const lengthRangeParams = this.filterParams.lengthRange;

        const filterBuildings = JSON.parse(JSON.stringify(this.buildings));

        console.log(parkFrontParams);
        console.log(this.filterParams);
        filterBuildings.map(building => {

            building.lots = building.lots.filter((lot) => {

                // filter by width
                if (lot.width < widthRangeParams.min || lot.width > widthRangeParams.max) {
                    return false;
                }
                // filter by length
                if (lot.length < lengthRangeParams.min || lot.length > lengthRangeParams.max) {
                    return false;
                }
                // filter by price
                if (lot.price < priceRangeParams.min || lot.price > priceRangeParams.max) {
                    return false;
                }
                // filter by status
                if (statusParams.length > 0 && !statusParams.includes(lot.status)) {
                    return false;
                }
                // filter by keywords
                if (this.keywords && !lot.lotNumber.toLowerCase().includes(this.keywords.toLowerCase())) {
                    return false;
                }
                // filter by parkFront
                if (parkFrontParams.length && parkFrontParams.length > 0 && !parkFrontParams.includes(lot.parkFront)) {
                    return false;
                }
                // filter by lakeFront
                if (lakeFrontParams.length && lakeFrontParams.length > 0 && !lakeFrontParams.includes(lot.lakeFront)) {
                    return false;
                }
                // filter by cornerBlock
                if (cornerBlockParams.length && cornerBlockParams.length > 0 && !cornerBlockParams.includes(lot.cornerBlock)) {
                    return false;
                }

                return true;
            });
            return building;
        });

        this.isFiltered = (JSON.stringify(this.filterParams) !== JSON.stringify(this.defaultFilterParams) || this.keywords !== '');

        this.updateSourceData(filterBuildings);
    }

    selectedLotsChange(buildingId) {
        this.selectedLots = this.dataSource.get(buildingId).data.filter((lot) => lot.isChecked === true);
        this.currentBuildingId = buildingId;
        this.showStatusBar = this.selectedLots.length > 0;
    }

    updateSourceData(buildings) {
        this.dataSourceCount = 0;
        buildings.map((building) => {
            this.dataSourceCount += building.lots.length;
            // 重新搜索，清空选中
            building.lots.map((lot) => {
                lot.isChecked = false;
            });

            let itemData: any = {
                data: building.lots ? building.lots.sort(this.compareLotNumber) : [],
                selection: new SelectionModel<any>(true, []),
            };

            this.dataSource.set(building.id, itemData);

        });
        console.log(this.dataSource);
    }

    compareLotNumber(a, b) {
        if (a.lotNumber < b.lotNumber) {
            return -1;
        }
        if (a.lotNumber > b.lotNumber) {
            return 1;
        }
        return 0;
    }
    clearFilterDataSearch() {
        this.isFiltered = false
        this.filterParams = JSON.parse(JSON.stringify(this.defaultFilterParams));
        this.filterData()
    }
    clearFilterData() {
        this.isFiltered = false
        this.filterParams = JSON.parse(JSON.stringify(this.defaultFilterParams));
        this.widthRangeSlider.resetFormGroup();
        this.widthRangeSlider.calculateFillBar();

        this.lengthRangeSlider.resetFormGroup();
        this.lengthRangeSlider.calculateFillBar();

        this.priceRangeSlider.resetFormGroup();
        this.priceRangeSlider.calculateFillBar();
    }

    stopPropagation($event: any) {
        $event.stopPropagation();
    }


    isAllSelected(buidlingId) {
        const numSelected = this.dataSource.get(buidlingId).selection.selected.length;
        const numRows = this.dataSource.get(buidlingId).data.filter(property => property.status !== 6).length;
        return numSelected === numRows;
    }

    masterToggle(buildingId) {
        const buildingItem = this.dataSource.get(buildingId);
        if (this.isAllSelected(buildingId)) {
            buildingItem.selection.clear();
            buildingItem.data.filter(property => property.status !== 6).forEach((property) => {
                property.isChecked = false;
            });

        } else {
            buildingItem.data.filter(property => property.status !== 6).forEach((property) => {
                buildingItem.selection.select(property);
                property.isChecked = true;
            });
        }
        this.selectedLotsChange(buildingId);
    }

    checkboxLabel(buildingId, row?: any): string {
        if (!row) {
            return `${this.isAllSelected(buildingId) ? 'select' : 'deselect'} all`;
        }
        return `${this.dataSource.get(buildingId).selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    tabChanged($event) {
        this.closeStatusBar();
    }

    changeMode(mode) {
        this.mode = mode;
    }

    closeStatusBar() {
        this.selectedLots.map((property) => {
            property.isChecked = false;
        });
        this.showStatusBar = false;
    }

    openDetailDialog(lot, building) {
        if(this.showDetailDialog) {
            return
        }
        this.showDetailDialog = true
        const dialogRef = this.dialog.open(LotDetailDialogComponent, {
            width: '900px',
            data: { lot: lot, project: this.project, building: building },
        });
        dialogRef.afterClosed().subscribe((result: any) => { 
            this.showDetailDialog = false
        });

        dialogRef.componentInstance.editProperty.subscribe(data => {
            this.dialog.open(EditPackagePropertyDialogComponent, {
                width: '95%',
                maxWidth: '1400px',
                data: {
                    project: this.project,
                    property: data.property
                }
            });
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddLotDialogComponent, {
            width: '800px',
            data: { project: this.project },
        });

        console.log(this.buildings);
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.newLot) {
                const building = this.buildings.find((building) => building.id === result.buildingId);
                if (!building.lots) {
                    building.lots = [];
                }

                building.lots.push(result.newLot);
                this.updateSourceData(this.buildings);
                this.initFilterParams();
                this.filterData();
            }
        });
    }

    openUpdateStatusDialog(targetStatus) {
        const dialogRef = this.dialog.open(UpdateLotStatusDialogComponent, {
            width: '400px',
            data: {
                lots: this.selectedLots,
                projectId: this.currentBuildingId,
                targetStatus
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.lots) {
                this.selectedLots.forEach((property) => {
                    property.isChecked = false;
                });

                const building = this.buildings.find((building) => building.id === result.projectId);

                building.lots = building.lots.map(lot => result.lots.find(p => p.id === lot.id) || lot);
                this.filterData();

                this.showStatusBar = false;
            }
        });
    }

    getStatusLabel(status) {
        switch (status) {
            case 0:
                return 'unavailable';
            case 1:
                return 'available';
            case 2:
                return 'reserved'; // eoi
            case 3:
                return 'reserved';
            case 4:
                return 'processing'; // exchanage conditional
            case 5:
                return 'processing'; // unconditional
            case 6:
                return 'sold';
        }
    }
}
